import { message as AntMessage } from 'antd'

import localforage from 'myStore'
import PostalMime from 'postal-mime'

import { getItem, setItem, removeItem } from 'libs/store'
import { trackObjectURL } from 'libs/CACHE/jmapDownloadCache'

import conf from 'conf'
import { getEnvParam } from 'env'

import imageDB from 'libs/DB/imageDB'

import JamClient from 'libs/jmap-jam'

import { convertHEIC, generateFilename } from 'utils'

import RestClient from 'services/restClient'
import { customFetchForXML } from 'services/jwt'

import { TYPE } from 'pages/main/data/defConstants'

import { emailSearchProvider } from 'vars'

import ext from './ext'
import { DownloadObj } from './downloadObj'
import { requestThreadOpenSearch } from './openSearchThread'
import { buildSearchThreadContract } from './openSearchMap'

export { DownloadObj }
export type { DownloadObjFile } from './downloadObj'

export const createUuid = ext.createUuid

export const fixedEmailProp = [
  'threadId',
  'hasAttachment',
  'from',
  'to',
  'cc',
  'bcc',
  'replyTo',
  'subject',
  'receivedAt',
  'size',
  'preview',
  'blobId',
  // 'headers',
  'header:Importance',
  'messageId',
  'inReplyTo',
  'references',
  'attachments',
]

export const changeableEmailProp = ['mailboxIds', 'keywords', 'receivedAt']

export const defaultEmailProp = [...fixedEmailProp, ...changeableEmailProp]

export const detailEmailProp = [
  ...defaultEmailProp,
  'headers',
  'sentAt',
  'bodyValues',
  'bodyStructure',
  'textBody',
  'htmlBody',
]

export const emailBodyProp = [
  'partId',
  'blobId',
  'size',
  'name',
  'type',
  'charset',
  'disposition',
  'cid',
  'language',
  'location',
  'header:Content-Type',
]

const customFetchForJmap = async (uri, options) => {
  return await customFetchForXML(uri, options, {
    getHeaders: async (token) => {
      const newTokenType = await localforage.getItem('app.user.jmap.tokenType')
      return {
        Authorization: `${newTokenType} ${token}`,
      }
    },
  })
}

const restClient = new RestClient('', customFetchForJmap, 'app.user.jmap.token', async (token) => {
  const tokenType = await localforage.getItem('app.user.jmap.tokenType')
  return Promise.resolve({
    key: 'Authorization',
    value: `${tokenType} ${token}`,
  })
})

const jam: any = {
  accountId: null,
  _client: null,
  getLastState: () => {
    return getItem('jam.lastState')
  },
  setLastState: (state) => {
    setItem('jam.lastState', state)
  },
  clear: () => {
    removeItem('jam.lastState')
  },
}

export async function createJAM(accessToken, tokenType) {
  try {
    if (jam._client == null) {
      const apiURL = getEnvParam('apiURL')
      const baseUrl = apiURL != null ? `https://${apiURL}` : conf.SERVER.BASE_URL
      jam._client = new JamClient({
        sessionUrl: `${baseUrl}/jmap`, // conf.SERVER.JMAP_URL,
        baseUrl,
        tokenType,
        token: accessToken,
        customFetch: async (uri, options) => {
          return await customFetchForXML(uri, options, {
            getHeaders: async (token) => {
              const newTokenType = await localforage.getItem('app.user.jmap.tokenType')
              // token 정보 갱신.
              jam._client.setAuthInfo(newTokenType, token)

              return {
                Authorization: `${newTokenType} ${token}`,
              }
            },
          })
        },
      })

      await jam._client.session

      const myAccount = await jam._client.getPrimaryAccount()

      jam.accountId = myAccount
    } else {
      await jam._client.session
    }
  } catch (e) {
    console.log('jam client err - ', e)
    jam.error = true
  }

  return jam
}

export function destroyJAM() {
  jam.accountId = null
  jam._client = null
  jam.error = null
  jam.clear()
}

export function getJamClient() {
  return jam._client
}

// const evtSrc = await jamClient.connectEventSource({
//   types: "*", // or ["Mailbox", "Email", ...]
//   ping: 5000, // ping interval in milliseconds
//   closeafter: "no", // or "state"
// });

export async function download(
  fileInfo,
  enableSave,
  isBlob,
  onProgress?,
  onBeforeSend?,
): Promise<any> {
  const accountId0 = jam.accountId
  const { downloadUrl } = await jam._client.session

  const promise = new Promise((resolve, reject) => {
    let name = fileInfo.name
    if (name != null) {
      // 파일명에 사용 금지 문자가 포함된 경우 다운로드 실패 방지를 위한 방어코드 적용.
      const forbiddenChars = /[\\/:*?"<>|#%&{}~@!$'`=+,;[\]()]/g
      name = name.replace(forbiddenChars, '_')
    }

    let url = downloadUrl.replace('{accountId}', encodeURIComponent(accountId0))
    url = url.replace('{blobId}', encodeURIComponent(fileInfo.blobId))
    url = url.replace('{name}', encodeURIComponent(name || ''))
    url = url.replace('{type}', encodeURIComponent(fileInfo.type || ''))

    const beforeFunc = (xhr) => {
      if (isBlob !== false) {
        restClient.xhrBlobType(xhr)
      }
      if (onBeforeSend != null) {
        onBeforeSend(xhr)
      }
    }

    restClient
      .xhrGet(url, null, onProgress, beforeFunc, {})
      .then(async ({ body }) => {
        console.log('xhrGetFile', body)

        const ret = new DownloadObj()
        ret.file = fileInfo

        if (isBlob === false) {
          ret.text = body
          resolve(ret)
          return
        }

        let blob = body

        let fileName = fileInfo.name
        const mimetype = fileInfo.type

        if (enableSave === true) {
          let downloadBlob = blob

          if (mimetype != null) {
            downloadBlob = new Blob([blob], { type: mimetype })
          }

          try {
            if (fileName === null && mimetype === 'message/rfc822') {
              const emlBuffer = await blob.arrayBuffer()
              const email = await PostalMime.parse(emlBuffer)
              console.log(' --- email data : ', email)

              const { subject } = email

              fileName = `${subject}.eml`

              ret.newFileName = fileName
            }
          } catch (e) {
            console.log('eml error : ', e)
            ret.newFileName = 'ForwardedMessage.eml'
          }

          ret.downloadPath = trackObjectURL(window.URL.createObjectURL(downloadBlob))

          ret.saveFile = () => {
            console.log(' - downloadImg : ', fileName, ret.downloadPath)
            const link = document.createElement('a')
            link.href = ret.downloadPath
            link.download = generateFilename(fileName)
            link.click()
            link.remove() // IE 미지원
          }
        }

        if (fileName != null) {
          // message/rfc822 - eml 파일인 경우에는 arraybuffer로 eml parser에 전달해야 한글이 깨지지 않음.
          if (mimetype.indexOf('text/') === 0) {
            ret.text = await blob.text()
          }
        }

        if (blob.type === 'text/xml' && fileName != null) {
          const lcFileName = fileName.toLowerCase()
          if (lcFileName.endsWith('.svg') === true) {
            blob = new Blob([blob], { type: 'image/svg+xml' })
          } else if (
            lcFileName.endsWith('.heic') === true ||
            lcFileName.endsWith('.heif') === true
          ) {
            const tmpFile = new File([blob], fileName, { type: mimetype || 'image/heic' })
            // createObjectURL에는 blob, file 모두 사용가능하므로, file을 blob 대신 전달.
            if (onProgress != null) {
              onProgress(null, null)
            }
            convertHEIC(tmpFile, 'image/jpeg', 0.8).then((imgBlob) => {
              console.log(imgBlob)
              if (onProgress != null) {
                onProgress(null, null)
              }
              ret.blob = imgBlob
              ret.path = trackObjectURL(window.URL.createObjectURL(imgBlob as any))
              resolve(ret)
            })
            return
          } else if (mimetype != null) {
            blob = new Blob([blob], { type: mimetype })
          }
        } else if (mimetype != null) {
          blob = new Blob([blob], { type: mimetype })
        } else {
          blob = new Blob([blob], { type: 'application/octet-stream' })
        }

        ret.path = trackObjectURL(window.URL.createObjectURL(blob))
        ret.blob = blob

        resolve(ret)
      })
      .catch((err) => {
        if (err.type !== 'abort') {
          AntMessage.info('download failed.')
        }
        // @todo - error 처리. - 404 file not found.
        reject(err)
      })
  })

  return promise
}

export async function downloadCheck(fileInfo) {
  const accountId0 = jam.accountId
  const { downloadUrl } = await jam._client.session

  let name = fileInfo.name
  if (name != null) {
    // 파일명에 사용 금지 문자가 포함된 경우 다운로드 실패 방지를 위한 방어코드 적용.
    const forbiddenChars = /[\\/:*?"<>|#%&{}~@!$'`=+,;[\]()]/g
    name = name.replace(forbiddenChars, '_')
  }

  let url = downloadUrl.replace('{accountId}', encodeURIComponent(accountId0))
  url = url.replace('{blobId}', encodeURIComponent(fileInfo.blobId))
  url = url.replace('{name}', encodeURIComponent(name || ''))
  url = url.replace('{type}', encodeURIComponent(fileInfo.type || ''))

  return restClient
    .head(url, null, {})
    .then(({ origin, data }) => {
      console.log('downloadCheck - ', origin, data)

      return true
    })
    .catch((err) => {
      if (err.type !== 'abort') {
        console.log('downloadCheck - err', err)
      }
      return false
    })
}

export async function upload(file, onProgress, beforeFunc) {
  const accountId0 = jam.accountId
  const { uploadUrl } = await jam._client.session

  const url = uploadUrl.replace('{accountId}', encodeURIComponent(accountId0))

  const blob = file

  return restClient
    .xhrPost(url, blob, onProgress, beforeFunc, {})
    .then(async ({ body }) => {
      console.log('upload file - ', body)
      const fileObj = JSON.parse(body)

      return fileObj
    })
    .catch((err) => {
      if (err.type !== 'abort') {
        AntMessage.info('upload failed.')
      }
      // @todo - error 처리. - 404 file not found.
      throw err
    })
}

export function getContentURL(fileInfo, accountId) {
  const promise = new Promise((resolve, reject) => {
    imageDB
      .getData(fileInfo.blobId)
      ?.then((data) => {
        // console.log(' --- image data --- ', data)
        if (data != null) {
          resolve(data.url)
          return
        }

        setTimeout(() => {
          download(fileInfo, false, true, null, accountId)
            .then((res) => {
              const { blob } = res as any
              imageDB.putData(fileInfo.blobId, blob)?.then((imgData) => {
                resolve(imgData.url)
              })
            })
            .catch(() => {
              reject(new Error('Download error.'))
            })
        }, 10)
      })
      .catch((e) => {
        console.log(' --- thumb load ', e)
        setTimeout(() => {
          download(fileInfo, false, true, null, accountId)
            .then((res) => {
              const { blob } = res as any
              imageDB.putData(fileInfo.blobId, blob)?.then((imgData) => {
                resolve(imgData.url)
              })
            })
            .catch(() => {
              reject(new Error('Download error.'))
            })
        }, 10)
      })
  })

  return promise
}

export function apiSet(apiType, options) {
  return jam._client.request([`${apiType}/set`, options])
}

export function jamUpdate(apiType, dataArray) {
  const update = {}

  dataArray.forEach((item) => {
    update[item.id] = {
      ...item,
    }
    delete update[item.id].id
  })

  const options = {
    accountId: jam.accountId,
    update,
  }

  return apiSet(apiType, options)
}

const checkState = (res, result) => {
  if (result.state != null) {
    res.lastState = result.state
  } else if (result.newState != null) {
    res.lastState = result.newState
  }

  if (res.lastState != null) {
    jam.setLastState(res.lastState)
  }

  if (result.queryState != null) {
    res.lastQueryState = result.queryState
  } else if (result.newQueryState != null) {
    res.lastQueryState = result.newQueryState
  }

  if (res.lastQueryState != null) {
    jam.lastQueryState = res.lastQueryState
  }

  return res
}

export function requestEmailIds(mailbox, options) {
  const { accountId } = jam

  let filter = mailbox.getJmapFilter()

  if (options.filter != null) {
    if (filter == null) {
      filter = options.filter
    } else if (filter.conditions == null) {
      if (options.useConditions == true) {
        filter = {
          conditions: [filter, options.filter],
          operator: 'AND',
        }
      } else {
        filter = {
          ...filter,
          ...options.filter,
        }
      }
    } else {
      filter.conditions.push(options.filter)
    }
  }

  const position = options.position || 0
  const limit = options.limit || 10

  return jam._client
    .requestMany((r) => {
      const emailIds = r.Email.query({
        accountId,
        filter,
        // calculateTotal: true, // 되도록 사용하지 않도록 할 것.
        calculateTotal: false, // 명시적으로 false로 설정 필요.
        position,
        limit,
      })

      return { emailIds }
    })
    .then(([{ emailIds }]) => {
      console.log(' -- emailIds : ', emailIds)

      const res = {}

      checkState(res, emailIds)

      return {
        emailIds: emailIds.ids,
        total: emailIds.total,
        info: res,
      }
    })
}

export function requestOneThread(emailId) {
  const { accountId } = jam

  return jam._client
    .requestMany((r) => {
      const emailsForThread = r.Email.get({
        accountId,
        ids: [emailId],
        properties: ['threadId'],
      })

      const threads = r.Thread.get({
        accountId,
        ids: emailsForThread.$ref('/list/*/threadId'),
      })

      const emails = r.Email.get({
        accountId,
        ids: threads.$ref('/list/*/emailIds'),
        properties: defaultEmailProp,
      })

      return { emailsForThread, threads, emails }
    })
    .then(([{ emailsForThread, threads, emails }]) => {
      // console.log(' -- emailIds : ', emailIds)
      console.log(' -- emailsForThread : ', emailsForThread)
      console.log(' -- threads : ', threads)
      console.log(' -- emails : ', emails)

      // this.addEmailData(threads.list, emails.list, emailIds.total)
      const res = {}

      checkState(res, emailsForThread)
      checkState(res, threads)
      checkState(res, emails)

      return {
        threadList: threads.list,
        emailList: emails.list,
        info: res,
      }
    })
}

export function requestEmailIdsByMessageId(messageId, mailbox) {
  const { accountId } = jam

  let filter = mailbox != null ? mailbox.getJmapFilter() : {}

  filter = {
    ...filter,
    header: ['message-id', messageId],
  }

  return jam._client
    .requestMany((r) => {
      const emailIds = r.Email.query({
        accountId,
        filter,
        sort: [
          {
            isAscending: false,
            property: 'receivedAt',
          },
        ],
        // collapseThreads가 true이면 동일한 threadId를 가진 메일 중 마지막 메일의 ID만을 얻어온다.
        collapseThreads: false,
        // calculateTotal: true, // 되도록 사용하지 않도록 할 것.
        calculateTotal: false, // 명시적으로 false로 설정 필요.
      })

      const emails = r.Email.get({
        accountId,
        ids: emailIds.$ref('/ids'),
        properties: changeableEmailProp,
      })

      return { emailIds, emails }
      // return { emailIds, emailsForThread, threads }
    })
    .then(([{ emailIds, emails }]) => {
      // .then(([{ emailIds, emailsForThread, threads }]) => {
      console.log(' -- emailIds : ', emailIds)

      return {
        emailIds: emailIds.ids,
        emailList: emails.list,
      }
    })
}

export function requestThreadByMessageId(messageId, mailbox) {
  const { accountId } = jam

  let filter = mailbox != null ? mailbox.getJmapFilter() : {}

  filter = {
    ...filter,
    header: ['message-id', messageId],
  }

  // const isEmailType = false

  return jam._client
    .requestMany((r) => {
      const emailIds = r.Email.query({
        accountId,
        filter,
        sort: [
          {
            isAscending: false,
            property: 'receivedAt',
          },
        ],
        // collapseThreads가 true이면 동일한 threadId를 가진 메일 중 마지막 메일의 ID만을 얻어온다.
        collapseThreads: true, // isEmailType !== true,
        // calculateTotal: true, // 가능한 사용하지 않도록 할 것.
        calculateTotal: false, // 명시적으로 false로 설정 필요.
      })

      const emailsForThread = r.Email.get({
        accountId,
        ids: emailIds.$ref('/ids'),
        properties: ['threadId'],
      })

      const threads = r.Thread.get({
        accountId,
        ids: emailsForThread.$ref('/list/*/threadId'),
      })

      const emails = r.Email.get({
        accountId,
        ids: threads.$ref('/list/*/emailIds'),
        properties: changeableEmailProp, // defaultEmailProp
      })

      return { emailIds, emailsForThread, threads, emails }
      // return { emailIds, emailsForThread, threads }
    })
    .then(([{ emailIds, emailsForThread, threads, emails }]) => {
      // .then(([{ emailIds, emailsForThread, threads }]) => {
      console.log(' -- emailIds : ', emailIds)
      console.log(' -- emailsForThread : ', emailsForThread)
      console.log(' -- threads : ', threads)
      // console.log(' -- emails : ', emails)

      // this.addEmailData(threads.list, emails.list, emailIds.total)
      const res = {
        enableQueryChange: false, // emailIds.canCalculateChanges === true,
      }

      // if (isEmailType === true) {
      //   checkState(res, emailIds)
      //   checkState(res, emails)

      //   return {
      //     emailIds: emailIds.ids,
      //     allEmailList: emails.list,
      //     // total: emailIds.total,
      //     info: res,
      //   }
      // }

      checkState(res, emailIds)
      checkState(res, emailsForThread)
      checkState(res, threads)
      checkState(res, emails)

      return {
        emailIds: emailIds.ids,
        threadList: threads.list,
        allEmailList: emails.list,
        // total: emailIds.total,
        info: res,
      }
    })
}

// OMD-21: OpenSearch 검색 결과(emailId 매치)를 스레드 묶음으로 재구성한다.
// 페이지네이션/total/hasMoreData 는 emailId 기준을 유지(Option A)하고, threadId dedupe·
// 스레드 전체 email 은 표시 계층(reqNextThreadList)이 THREAD 계약을 그대로 소비하도록 맞춘다.
// - emailIds        : OpenSearch 매치 raw id (desc). hasMoreData(length===limit)/경계 판정용.
// - emailsForThread : 스레드당 대표(최신 매치) [{ id, threadId }]. titleEmail 설정용.
// - threadList      : Thread/get 결과 [{ id, emailIds:[스레드 전체] }].
// - allEmailList    : 스레드 전체 emailId 의 어댑팅 항목(매치=OpenSearch 마커 유지, 비매치=최소
//                     항목). messageId 가 없어 reqNextThreadList 의 fake 2단계 로딩으로 채워진다.
async function requestSearchThread(mailbox, options) {
  const base = await requestThreadOpenSearch(mailbox, options)
  const matchedIds = base.emailIds

  if (matchedIds.length === 0) {
    return {
      emailIds: [],
      emailsForThread: [],
      threadList: [],
      allEmailList: [],
      total: base.total,
      info: base.info,
    }
  }

  const { accountId } = jam

  const [{ emailsForThread, threads }] = await jam._client.requestMany((r) => {
    const emailsForThreadRef = r.Email.get({
      accountId,
      ids: matchedIds,
      properties: ['threadId'],
    })
    const threadsRef = r.Thread.get({
      accountId,
      ids: emailsForThreadRef.$ref('/list/*/threadId'),
    })
    return { emailsForThread: emailsForThreadRef, threads: threadsRef }
  })

  const { emailsForThread: emailsForThreadList, allEmailList } = buildSearchThreadContract(
    base.allEmailList,
    emailsForThread.list,
    threads.list,
  )

  return {
    emailIds: matchedIds,
    emailsForThread: emailsForThreadList,
    threadList: threads.list,
    allEmailList,
    total: base.total,
    info: base.info,
  }
}

export function requestThread(mailbox, options) {
  // OFM-212: 검색 모드에서 OpenSearch 백엔드 사용. 일반 메일함 목록은 JMAP 유지.
  if (emailSearchProvider === 'OPEN_SEARCH' && mailbox.isSearchMode?.() === true) {
    // OMD-21: 표시 단위가 THREAD면 OpenSearch가 준 emailId 매치 결과를 스레드로 재구성한다.
    const searchType = options.type != null ? options.type : TYPE.THREAD
    if (searchType === TYPE.THREAD) {
      return requestSearchThread(mailbox, options)
    }
    return requestThreadOpenSearch(mailbox, options)
  }

  const { accountId } = jam

  let filter = mailbox.getJmapFilter()

  const type = options.type != null ? options.type : TYPE.THREAD

  const isEmailType = type === TYPE.EMAIL

  const position = options.position || 0
  const limit = options.limit || 10

  if (options.text != null && options.text.length > 0) {
    const searchTextList = options.text
      .split(' ')
      .filter((text) => {
        return text.trim().length > 0
      })
      .map((text) => {
        return {
          text: text.trim(),
        }
      })

    let searchFilters = null

    if (searchTextList.length === 1) {
      searchFilters = searchTextList[0]
    } else {
      searchFilters = {
        conditions: searchTextList,
        operator: 'OR',
      }
    }

    if (searchFilters != null) {
      if (filter == null) {
        filter = searchFilters
      } else if (filter.conditions == null) {
        filter = {
          conditions: [filter, searchFilters],
          operator: 'AND',
        }
      } else {
        filter.conditions.push(searchFilters)
      }
    }
  }

  if (options.filters != null && options.filters.length > 0) {
    if (filter == null) {
      if (options.filters.length === 1) {
        filter = options.filters[0]
      } else {
        filter = {
          conditions: [...options.filters],
          operator: 'AND',
        }
      }
    } else if (filter.conditions == null) {
      filter = {
        conditions: [filter, ...options.filters],
        operator: 'AND',
      }
    } else {
      filter.conditions = [...filter.conditions, ...options.filters]
    }
  }
  let sorts = []
  if (options.sorts != null && options.sorts.length > 0) {
    sorts = [...options.sorts]
  }

  // 날짜 검색이 없으면 날짜 검색을 추가.
  // if (sorts.find((sort) => sort.property === 'receivedAt') == null) {
  //   sorts.push({
  //     isAscending: false,
  //     property: 'receivedAt',
  //   })
  // }

  return jam._client
    .requestMany((r) => {
      const emailIds = r.Email.query({
        accountId,
        filter,
        sort: sorts,
        // collapseThreads가 true이면 동일한 threadId를 가진 메일 중 마지막 메일의 ID만을 얻어온다.
        collapseThreads: isEmailType !== true,
        // calculateTotal: true, // 되도록 사용하지 않도록 할 것.
        calculateTotal: options != null && options.needTotal === true ? true : false, // 명시적으로 false로 설정 필요.
        position,
        limit,
      })

      if (isEmailType === true) {
        const emails = r.Email.get({
          accountId,
          ids: emailIds.$ref('/ids'),
          properties: [
            'threadId',
            ...changeableEmailProp, // defaultEmailProp
          ],
        })

        return { emailIds, emails }
        // return { emailIds }
      }

      const emailsForThread = r.Email.get({
        accountId,
        ids: emailIds.$ref('/ids'),
        properties: ['threadId'],
      })

      const threads = r.Thread.get({
        accountId,
        ids: emailsForThread.$ref('/list/*/threadId'),
      })

      const emails = r.Email.get({
        accountId,
        ids: threads.$ref('/list/*/emailIds'),
        properties: changeableEmailProp, // defaultEmailProp
      })

      return { emailIds, emailsForThread, threads, emails }
      // return { emailIds, emailsForThread, threads }
    })
    .then(([{ emailIds, emailsForThread, threads, emails }]) => {
      // .then(([{ emailIds, emailsForThread, threads }]) => {
      console.log(' -- emailIds : ', emailIds)
      console.log(' -- emailsForThread : ', emailsForThread)
      console.log(' -- threads : ', threads)
      // console.log(' -- emails : ', emails)

      // this.addEmailData(threads.list, emails.list, emailIds.total)
      const res = {
        enableQueryChange: false, // emailIds.canCalculateChanges === true,
      }

      if (isEmailType === true) {
        checkState(res, emailIds)
        checkState(res, emails)

        return {
          emailIds: emailIds.ids,
          allEmailList: emails.list,
          total: emailIds.total,
          info: res,
        }
      }

      checkState(res, emailIds)
      checkState(res, emailsForThread)
      checkState(res, threads)
      checkState(res, emails)

      return {
        emailIds: emailIds.ids,
        emailsForThread: emailsForThread.list,
        threadList: threads.list,
        allEmailList: emails.list,
        total: emailIds.total,
        info: res,
      }
    })
}

// queryChange 오류 발생. 나중에 확인 후 다시 적용 여부 결정.
export function requestUpdatedThreadQuery(mailbox, options) {
  const { accountId } = jam

  // @todo - queryChange의 결과로는 다른 client에서 이동되거나 삭제된 이메일에 대한 처리를 제대로 할 수 없음.
  // 추후 다시 적용 여부 결정.
  const enableQueryChange = mailbox.enableQueryChange

  const maxChanges = options.maxChanges || 20
  const sinceState = options.sinceState || undefined

  let queryChangesOptions = null

  if (enableQueryChange === true) {
    let filter = mailbox.getJmapFilter()

    const type = options.type != null ? options.type : TYPE.THREAD

    const isEmailType = type === TYPE.EMAIL

    // const { threadList } = mailbox;
    const firstMessageId = null
    // (threadList.length > 0 && threadList[0].emailIds.length > 0) ?
    //   threadList[0].emailIds[threadList[0].emailIds.length - 1] : null

    const sinceQueryState = options.sinceQueryState || undefined

    if (options.text != null) {
      const searchFilter = {
        text: options.text,
      }

      if (filter == null) {
        filter = searchFilter
      } else if (filter.conditions == null) {
        filter = {
          conditions: [filter, searchFilter],
          operator: 'AND',
        }
      } else {
        filter.conditions.push({
          text: options.text,
        })
      }
    }

    queryChangesOptions = {
      accountId,
      sort: [
        {
          isAscending: false,
          property: 'receivedAt',
        },
      ],
      collapseThreads: isEmailType !== true,
      // calculateTotal: true, // 가능한 사용하지 않도록 할 것.
      calculateTotal: false, // 명시적으로 false로 설정 필요.
      sinceQueryState,
      maxChanges,
    }
    if (firstMessageId != null) {
      queryChangesOptions.upToId = firstMessageId
    }
    if (filter != null) {
      queryChangesOptions.filter = filter
    }
  }

  return jam._client
    .requestMany((r) => {
      // querychanges - 오동작 확인 - added와 removed에 동일한 ID가 전달됨.
      const emailChanges = r.Email.changes({
        accountId,
        sinceState,
        maxChanges,
      })

      let ret = null

      if (enableQueryChange === true) {
        const emailQueryChanges = r.Email.queryChanges(queryChangesOptions)
        const addedEmails = r.Email.get({
          accountId,
          ids: emailQueryChanges.$ref('/added/*/id'),
          properties: defaultEmailProp,
        })

        const deletedEmails = r.Email.get({
          accountId,
          ids: emailQueryChanges.$ref('/removed/*'),
          properties: defaultEmailProp,
        })

        ret = { emailChanges, emailQueryChanges, addedEmails, deletedEmails }
      } else {
        const createdEmails = r.Email.get({
          accountId,
          ids: emailChanges.$ref('/created/*'),
          properties: defaultEmailProp,
        })

        const updatedEmails = r.Email.get({
          accountId,
          ids: emailChanges.$ref('/updated/*'),
          properties: defaultEmailProp,
        })

        const destroyedEmails = r.Email.get({
          accountId,
          ids: emailChanges.$ref('/destroyed/*'),
          properties: ['threadId', 'mailboxIds'],
        })

        ret = { emailChanges, createdEmails, updatedEmails, destroyedEmails }
      }

      return ret
    })
    .then(
      ([
        {
          emailChanges,
          createdEmails,
          updatedEmails,
          destroyedEmails,
          emailQueryChanges,
          addedEmails,
          deletedEmails,
        },
      ]) => {
        console.log(' -- emailChanges : ', emailChanges)
        console.log(' -- emailQueryChanges : ', emailQueryChanges)
        console.log(' -- addedEmails : ', addedEmails)
        console.log(' -- deletedEmails : ', deletedEmails)
        console.log(' -- createdEmails : ', createdEmails)
        console.log(' -- updatedEmails : ', updatedEmails)
        console.log(' -- destroyedEmails : ', destroyedEmails)

        const res: any = {}

        if (emailQueryChanges != null) {
          checkState(res, emailQueryChanges)
        }

        if (res.hasMoreChanges == null) {
          res.hasMoreChanges = emailChanges.hasMoreChanges === true
          checkState(res, emailChanges)
        }

        return {
          emailChanges,
          emailQueryChanges,
          addedEmails,
          deletedEmails,
          createdEmails,
          updatedEmails,
          destroyedEmails,
          info: res,
        }
      },
    )
}

export function requestUpdatedThread(options) {
  const { accountId } = jam

  const maxChanges = 50 // options.maxChanges || 20
  const sinceState = options.sinceState || undefined

  return jam._client
    .requestMany((r) => {
      const emailChanges = r.Email.changes({
        accountId,
        sinceState,
        maxChanges,
      })

      // 새로 생성된 메일은 모든 정보가 필요.
      const createdEmails = r.Email.get({
        accountId,
        ids: emailChanges.$ref('/created/*'),
        properties: defaultEmailProp,
      })

      // 다른 폴더에서 이동된 메일인 경우 전체 정보가 필요하므로, 전체 정보를 가져온다.
      const updatedEmails = r.Email.get({
        accountId,
        ids: emailChanges.$ref('/updated/*'),
        properties: defaultEmailProp,
      })

      // destroy된 메일은 ID정보만 필요.
      const destroyedEmails = r.Email.get({
        accountId,
        ids: emailChanges.$ref('/destroyed/*'),
        properties: ['threadId', 'mailboxIds'],
      })

      return { emailChanges, createdEmails, updatedEmails, destroyedEmails }
    })
    .then(([{ emailChanges, createdEmails, updatedEmails, destroyedEmails }]) => {
      console.log(' -- emailChanges : ', emailChanges)
      console.log(' -- createdEmails : ', createdEmails)
      console.log(' -- updatedEmails : ', updatedEmails)
      console.log(' -- destroyedEmails : ', destroyedEmails)

      // this.addEmailData(threads.list, emails.list, emailIds.total)

      const res = {}
      checkState(res, emailChanges)
      checkState(res, createdEmails)
      checkState(res, updatedEmails)
      checkState(res, destroyedEmails)

      return {
        emailChanges,
        createdEmails,
        updatedEmails,
        destroyedEmails,
        info: res,
      }
    })
}

export async function getCount(options, filters) {
  const { accountId } = jam

  const type = options.type != null ? options.type : TYPE.EMAIL
  const isEmailType = type !== TYPE.THREAD

  const query: any = {
    accountId,
    collapseThreads: isEmailType !== true,
    calculateTotal: true,
    position: 0,
    limit: 0,
  }

  if (filters != null) {
    query.filter = filters
  }

  const [result] = await jam._client.request(['Email/query', query])
  const ret = {
    result,
    count: 0,
  }
  if (result != null && result.total != null) {
    ret.count = result.total
  }

  return ret
}

export async function getQuota() {
  const { accountId } = jam

  const query = {
    accountId,
    ids: null,
  }

  try {
    const [result] = await jam._client.request(['Quota/get', query], {
      using: ['urn:ietf:params:jmap:core', 'https://cyrusimap.org/ns/jmap/quota'],
    })
    return result.list
  } catch (error) {
    console.log('getQuota error : ', error)
  }
  return null
}

export function getEmailsByIds(emailIds, loadThread = false) {
  const { accountId } = jam

  return jam._client
    .requestMany((r) => {
      if (loadThread !== true) {
        const emails = r.Email.get({
          accountId,
          ids: emailIds,
          properties: [...defaultEmailProp],
        })
        return { emails }
      }

      const emailsForThread = r.Email.get({
        accountId,
        ids: emailIds,
        properties: ['threadId'],
      })

      const threads = r.Thread.get({
        accountId,
        ids: emailsForThread.$ref('/list/*/threadId'),
      })

      const emails = r.Email.get({
        accountId,
        ids: threads.$ref('/list/*/emailIds'),
        properties: [...defaultEmailProp], // defaultEmailProp
      })

      return { emailsForThread, threads, emails }
    })
    .then(([{ emailsForThread, threads, emails }]) => {
      console.log(' -- getEmailsByIds emailsForThread: ', emailsForThread)
      console.log(' -- getEmailsByIds : ', threads)
      console.log(' -- getEmailsByIds : ', emails)
      return {
        threadList: threads != null ? threads.list : null,
        emailList: emails.list,
      }
    })
}

let mailIdx = 1

export function createEmail(messageObj, previousDraft, sendMail) {
  messageObj.accountId = jam.accountId

  const { accountId, createProp, emailSubmissionProps, sentBoxId, drafts } = ext.createEmailParam(
    messageObj,
    previousDraft,
  )

  // const uuid1 = createUuid()
  // const uuid2 = createUuid()

  let createEmailProp: any = null
  let sendMailId: string = ''

  if (previousDraft == null || sendMail !== true) {
    const uuid1 = `k${mailIdx}`
    mailIdx += 1

    createEmailProp = {
      accountId,
      create: {
        [uuid1]: createProp,
      },
    }

    sendMailId = `#${uuid1}`
  } else {
    sendMailId = previousDraft.id
  }

  const uuid2 = `k${mailIdx}`
  mailIdx += 1

  if (createEmailProp != null && previousDraft != null && previousDraft.id != null) {
    createEmailProp.destroy = [previousDraft.id]
  }

  return getJamClient()
    .requestMany((r) => {
      const createdEmail = createEmailProp != null ? r.Email.set(createEmailProp) : undefined

      const onSuccess = {
        'keywords/$draft': null,
        [`mailboxIds/${sentBoxId}`]: true,
      }

      if (drafts != null) {
        onSuccess[`mailboxIds/${drafts.id}`] = null
      }

      let emailSubmissionSet =
        sendMail === true
          ? r.EmailSubmission.set({
              accountId,
              create: {
                [uuid2]: {
                  emailId: sendMailId,
                  ...emailSubmissionProps,
                },
              },
              onSuccessUpdateEmail: {
                [`#${uuid2}`]: onSuccess,
              },
            })
          : undefined

      const emailChanges = r.Email.changes({
        accountId,
        sinceState: jam.getLastState(),
        maxChanges: 20,
      })

      const mailboxChanges = r.Mailbox.changes({
        accountId,
        sinceState: jam.getLastState(),
      })

      const mailboxGet1 = r.Mailbox.get({
        accountId,
        ids: mailboxChanges.$ref('/created'),
      })

      const mailboxGet2 = r.Mailbox.get({
        accountId,
        ids: mailboxChanges.$ref('/updated'),
        // properties: mailboxChanges.$ref('/updatedProperties'),
      })

      const emailGet = r.Email.get({
        accountId,
        ids: emailChanges.$ref('/created'),
        properties: defaultEmailProp,
      })

      // 중복되는 부분으로 보임.
      // const mailboxGet3 = r.Mailbox.get({
      //   accountId,
      //   ids: [drafts.id],
      //   properties: [
      //     'totalEmails',
      //     'unreadEmails',
      //     'totalThreads',
      //     'unreadThreads'
      //   ]
      // });

      // console.log(' -- createdEmail : ', createdEmail)
      // console.log(' -- emailSubmissionSet : ', emailSubmissionSet)
      // console.log(' -- emailChanges : ', emailChanges)
      // console.log(' -- mailboxChanges : ', mailboxChanges)
      // console.log(' -- mailboxGet1 : ', mailboxGet1)
      // console.log(' -- mailboxGet2 : ', mailboxGet2)
      if (createdEmail != null && emailSubmissionSet == null) {
        return { createdEmail, emailChanges, mailboxChanges, mailboxGet1, mailboxGet2, emailGet }
      }

      if (createdEmail == null && emailSubmissionSet != null) {
        return {
          emailSubmissionSet,
          emailChanges,
          mailboxChanges,
          mailboxGet1,
          mailboxGet2,
          emailGet,
        }
      }

      return {
        createdEmail,
        emailSubmissionSet,
        emailChanges,
        mailboxChanges,
        mailboxGet1,
        mailboxGet2,
        emailGet,
      }
    })
    .then(
      ([
        {
          createdEmail,
          emailSubmissionSet,
          emailChanges,
          mailboxChanges,
          mailboxGet1,
          mailboxGet2,
          emailGet,
        },
      ]) => {
        // console.log(' -- createdEmail : ', createdEmail)
        // console.log(' -- emailSubmissionSet : ', emailSubmissionSet)
        // console.log(' -- emailChanges : ', emailChanges)
        // console.log(' -- mailboxChanges : ', mailboxChanges)
        // console.log(' -- mailboxGet1 : ', mailboxGet1)
        // console.log(' -- mailboxGet2 : ', mailboxGet2)

        return {
          createdEmail,
          emailSubmissionSet,
          emailChanges,
          mailboxChanges,
          mailboxGet1,
          mailboxGet2,
          emailGet,
        }
      },
    )
}

export function deleteEmails(emailList) {
  const deleteEmailsProp = {
    accountId: jam.accountId,
    destroy: emailList.map((email) => {
      return email.data.id
    }),
  }

  return jam._client.request(['Email/set', deleteEmailsProp]).then(([deletedEmail]) => {
    return { deletedEmail }
  })
}

export function deleteEmailsById(emailIdList) {
  const deleteEmailsProp = {
    accountId: jam.accountId,
    destroy: emailIdList,
  }

  return jam._client.request(['Email/set', deleteEmailsProp]).then(([deletedEmail]) => {
    return { deletedEmail }
  })
}

export function updateMailboxes(update) {
  // update = {
  //   [mailboxId]: {
  //     name: newName,
  //   }
  // }
  return getJamClient()
    .request([
      'Mailbox/set',
      {
        accountId: jam.accountId,
        update,
      },
    ])
    .then(([res]) => {
      console.log('update mailbox : ', res)
      if (res.updated != null) {
        const ret = {}
        Object.keys(res.updated).forEach((mailboxId) => {
          ret[mailboxId] = update[mailboxId]
        })
        return ret
      } else if (res.notUpdated != null) {
        const mailboxId = Object.keys(res.notUpdated)[0]
        const val = res.notUpdated[mailboxId] // notUpdated는 map & property.
        if (val != null) {
          return { error: val }
        }
      }
      return null
    })
}

export function deleteMailbox(mailboxId, removeEmails = false) {
  return getJamClient()
    .request([
      'Mailbox/set',
      {
        accountId: jam.accountId,
        destroy: [mailboxId],
        onDestroyRemoveEmails: removeEmails,
      },
    ])
    .then(([res]) => {
      console.log('destroy mailbox : ', res)
      if (res.destroyed != null) {
        if (res.destroyed.indexOf(mailboxId) > -1) {
          // destroyed는 array.
          return { deleted: [mailboxId] }
        }
      } else if (res.notDestroyed != null) {
        const val = res.notDestroyed[mailboxId] // notDestroyed는 map & property.
        if (val != null) {
          return { error: val }
        }
      }
      return { error: { type: 'unknown error' } }
    })
}

export function copyEmail(emailIds, mailboxId) {
  const emails = {}

  emailIds.forEach(async (emailId) => {
    const uuid1 = `k${mailIdx}`
    mailIdx += 1

    emails[uuid1] = {
      // accountId: jam.accountId,
      // fromAccountId: jam.accountId,
      id: emailId,
      mailboxIds: { [mailboxId]: true },
    }
  })

  return getJamClient().api.Email.copy({
    fromAccountId: jam.accountId,
    accountId: jam.accountId,
    create: emails,
    onSuccessDestroyOriginal: true,
  })
}

export async function importEML(
  emlFiles,
  mailboxId,
  receivedAt,
  onProgress /*, isDraft, isRead */,
): Promise<any> {
  let emails = {}
  let count = 0

  const importLimit = 10

  const fileMap = {}
  const uploadFailedFiles = [] // [emlFiles[0], emlFiles[1], emlFiles[2]]

  const existingEmailIds = []
  const existingFiles = []

  const invalidFiles = []

  const ids = []

  const applyImportEml = async () => {
    const ret1 = await getJamClient().request([
      'Email/import',
      {
        accountId: jam.accountId,
        ifInState: null,
        emails,
      },
    ])
    const [res1] = ret1

    for (const createID of Object.keys(res1.notCreated)) {
      const { type } = res1.notCreated[createID]
      // 'alreadyExists'
      if (type === 'alreadyExists') {
        const { existingId } = res1.notCreated[createID]
        existingEmailIds.push(existingId)
        existingFiles.push(fileMap[createID])
        //  return false;
        // const error = new Error(`import eml error - ${type}`)
        // error.type = type
        // error.existingId = existingId
      } else if (type === 'invalidEmail') {
        invalidFiles.push(fileMap[createID])
      } else {
        // 기타 에러 발생 시 처리 중단.
        const error: any = new Error(`import eml error - ${type}`)
        error.type = type
        throw error
      }
    }

    const ids0 = Object.keys(res1.created).map((createID) => {
      const { id } = res1.created[createID]
      return id
    })

    ids.push(...ids0)
  }

  const resList = []
  for (const emlFile of emlFiles) {
    try {
      const uploadRes = await upload(emlFile, null, null)
      const { blobId } = uploadRes as any

      const uuid1 = `k${mailIdx}`
      mailIdx += 1

      emails[uuid1] = {
        blobId,
        mailboxIds: { [mailboxId]: true },
        // keywords: { $draft: (isDraft === true), $seen: (isRead === true) },
        receivedAt,
      }

      fileMap[uuid1] = emlFile

      if (onProgress != null) {
        count += 1
        let progress = Math.floor((count / emlFiles.length) * 100)
        if (progress >= 100) {
          progress = 99
        }
        onProgress(progress, count, emlFiles.length)
      }

      resList.push(uploadRes)
    } catch (e) {
      uploadFailedFiles.push(emlFile)
      console.log(e)
      resList.push(null)
    }

    // importLimit만큼 업로드되면, import를 실행.
    if (Object.keys(emails).length >= importLimit) {
      try {
        await applyImportEml()
      } catch (error) {
        console.error('[importEML] batch import failed:', (error as Error).message)
        break
      }
      emails = {} // import에 성공하면 import데이터 초기화.
    }
  }

  // 모두 업로드가 완료되면 emails에 남아있는 것들을 모두 import.
  if (Object.keys(emails).length > 0) {
    try {
      await applyImportEml()
    } catch (error) {
      console.error('[importEML] final batch import failed:', (error as Error).message)
    }
    emails = {} // import에 성공하면 import데이터 초기화.
  }

  // if (existingEmailIds.length > 0) {
  //   try {
  //     const copyRet = await copyEmail(existingEmailIds, mailboxId)
  //     const [copyRes] = copyRet

  //     console.log(' -- copyRes : ', copyRes)
  //   } catch (error) {
  //     const { type, arguments: arguments0 } = error
  //     let err = null
  //     if (type === 'invalidArguments') {
  //       err = new Error(`copy email error - ${type}, ${arguments0.join(', ')}`)
  //     } else {
  //       err = new Error(`copy email error - ${type}`)
  //     }
  //     err.type = type
  //     throw err
  //   }
  // }

  const ret2 = await getJamClient().request([
    'Email/get',
    {
      accountId: jam.accountId,
      ids,
      properties: defaultEmailProp,
    },
  ])

  const [res2] = ret2

  if (onProgress != null) {
    onProgress(100, emlFiles.length, emlFiles.length)
  }

  const errors = []
  if (existingEmailIds.length > 0 || uploadFailedFiles.length > 0 || invalidFiles.length > 0) {
    if (existingEmailIds.length > 0) {
      const error: any = new Error(`import eml error - alreadyExists`)
      error.type = 'alreadyExists'
      error.existingIds = existingEmailIds
      error.existingFiles = existingFiles
      errors.push(error)
    }
    if (uploadFailedFiles.length > 0) {
      const error: any = new Error(`import eml error - uploadFails`)
      error.type = 'uploadFails'
      error.uploadFailedFiles = uploadFailedFiles
      errors.push(error)
    }
    if (invalidFiles.length > 0) {
      const error: any = new Error(`import eml error - invalidFiles`)
      error.type = 'invalidFiles'
      error.invalidFiles = invalidFiles
      errors.push(error)
    }
  }

  return { emailList: res2, errors }
}

export { jam }

const jamUtil = {
  jam,
  createJAM,
  destroyJAM,
  getJamClient,
  download,
  getContentURL,
  createUuid,
  apiSet,
  requestUpdatedThreadQuery,
  requestUpdatedThread,
  requestEmailIds,
  requestThread,
  getCount,
  createEmail,
  deleteEmails,
  deleteEmailsById,
  updateMailboxes,
  deleteMailbox,
}

export default jamUtil
